import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { type Types } from '@fiverr-private/theme';

const DropdownSection = ({ children }: Pick<Types.FlexLayoutProps, 'children'>) => (
  <Stack width="100%" gap="0" direction="column">
    {children}
  </Stack>
);

DropdownSection.displayName = 'DropdownSection';
export default DropdownSection;
